import React, { useState } from 'react';
import { BrowserRouter as Router, Redirect, Route, useHistory } from 'react-router-dom';
import Login from '../Pages/Start/Login';
import EmployeeLogin from '../Pages/Start/EmployeeLogin';
import Dashboard from '../Pages/Employee/Dashboard/Dashboard';
import SafetyTesting from '../Pages/Employee/Safety/SafetyTesting';
import SafetyTestingEdit from '../Pages/Employee/Safety/safety-testing-edit';
import Railroad from '../Pages/Employee/Safety/Enter-RailRoad-Add';
import CreateTicket from '../Pages/Employee/Ticket/CreateTicket';
import BroadcastMessages from '../Pages/Broadcast/BroadcastMessages';
import NewHireQueue from '../Pages/HR/NewHireQueue/NewHireQueue';
import TicketsAndAlerts from '../Pages/HR/TicketsAndAlerts/TicketsAndAlerts';
import Employees from '../Pages/HR/Employees/Employees';
import NewHireStep1 from '../Pages/HR/NewHireQueue/NewHireStep1';
import NewHireStep2 from '../Pages/HR/NewHireQueue/NewHireStep2';
import AlartUpdate from '../Pages/HR/TicketsAndAlerts/AlartUpdate';
import TicketUpdate from '../Pages/HR/TicketsAndAlerts/TicketUpdate';
import EmployeeResult from '../Pages/HR/Employees/Result';
import EmployeesProfile from '../Pages/HR/Employees/EmployeesProfile';
import ProfileResult from '../Pages/HR/Employees/ProfileResult';
import Termination from '../Pages/HR/Employees/Termination';
import Application from '../Pages/Applicant/Application/Application';
import Documents from '../Pages/Applicant/Documents/Documents';
import CreatePassword from '../Pages/Applicant/Application/CreatePassword';
import Questionnaire from '../Pages/Applicant/Application/Questionnaire';
import Submission from '../Pages/Applicant/Application/Submission';
import Submission5 from '../Pages/Applicant/Application/SubmissionStatus5';
import DocumentsStep3 from '../Pages/Applicant/Documents/DocumentsStep3';
import DocumentsStep4 from '../Pages/Applicant/Documents/DocumentsStep4';
import SubmissionComplete from '../Pages/Applicant/Application/SubmissionComplete';
import Terminated from '../Pages/HR/Employees/Terminated';
import ConditionalOffer from '../Pages/Applicant/Documents/Documents/ConditionalOffer';
import PostConditionalJobOffer from '../Pages/Applicant/Documents/Documents/PostConditionalJobOffer';
import PostConditionalJobOffer2 from '../Pages/Applicant/Documents/Documents/PostConditionalJobOffer2';
import PostConditionalJobOffer3 from '../Pages/Applicant/Documents/Documents/PostConditionalJobOffer3';
import PostConditionalJobOffer4 from '../Pages/Applicant/Documents/Documents/PostConditionalJobOffer4';
import FuelCardAgreement from '../Pages/Applicant/Documents/Documents/FuelCardAgreement';
import BootCardAgreement from '../Pages/Applicant/Documents/Documents/BootCardAgreement';
import TWICCardPaymentAgreement from '../Pages/Applicant/Documents/Documents/TWIC-CardPaymentAgreement';
import DirectDeposit from '../Pages/Applicant/Documents/Documents/DirectDeposit';
import FCRA from '../Pages/Applicant/Documents/Documents/FCRA';
import ArbitrationAgreement from '../Pages/Applicant/Documents/Documents/ArbitrationAgreement';
import Harassment from '../Pages/Applicant/Documents/Documents/Harassment';
import EmployeeAgreement from '../Pages/Applicant/Documents/Documents/EmployeeAgreement';
import EmployeeHandbook from '../Pages/Applicant/Documents/Documents/EmployeeHandbook';
import SafetyHandbook from '../Pages/Applicant/Documents/Documents/SafetyHandbook';
import DrugAlcoholWeapons from '../Pages/Applicant/Documents/Documents/DrugAlcoholWeapons';
import OnBoarding from '../Pages/ITManager/Onboarding/onBoarding';
import NewHireQueueIT from '../Pages/ITManager/NewHireQueue/newHireITQueue';
import EnterCheckRide from '../Pages/Employee/Safety/Enter-CheckRide';
import DepartmentInner from '../Components/LayoutComponents/DepartmentInner';
import { HTDept, loaders, utility } from '../Components/TableComponents/constants';
import services from '../Services';
import ContactInfoForm from '../Components/ContactInfo/ContactInfoForm';
import ApplicationContact from '../Components/ContactInfo/ApplicationContact';
import UpdatedDepositeForm from '../Components/DirectDepositeForm/updatedDepositeForm';
import ApprovalRejected from '../Pages/Applicant/Application/ApprovalRejected';
import ApplicantPassword from '../Pages/Applicant/Application/ApplicantPassword';
import ApplicantForget from '../Pages/Applicant/Application/ApplicantForget';
import DriverInformation from '../Pages/Applicant/Documents/Documents/DriverInformationForm';
import CompanyPropertyReturn from '../Pages/Applicant/Documents/Documents/CompanyPropertyReturn';
import ReleaseAndDocumentation from '../Pages/Applicant/Documents/Documents/ReleaseAndDocumentation';
import HardwareManagement from '../Components/Hardware/HardwareManagement';
import { useEffect } from 'react';
import Layout from './Layout';
import { Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import LoaderLayout from './LoaderLayout';
import EnterIncident from '../Pages/Employee/Safety/Enter-incident';
import EnterIncidentAntd from '../Pages/Employee/Safety/EnterIncident';
import LocomotiveLookup from '../Pages/Locomotive/LocomotiveLookup';
import LocomotiveTickets from '../Pages/Locomotive/LocomotiveTickets';
import LocomotiveWorkOrders from '../Pages/Locomotive/LocomotiveWorkOrders';
import LocomotiveListing from '../Pages/Locomotive/LocomotiveListing';
import LocomotiveEdit from '../Pages/Locomotive/locomotiveEdit';
import LocomotiveTicketEdit from '../Pages/Locomotive/LocomotiveTicketEdit';
import EmployeeCheck from './EmployeeCheck';
import TicketAndAlertUpdate from '../Pages/HR/TicketsAndAlerts/TicketAndAlertUpdate';
import EquipmentLookup from '../Pages/Locomotive/EquipmentLookup';
import EquipmentLookUpEdit from '../Pages/Locomotive/EquipmentLookupEdit';
import LocomotiveWorkOrderEdit from '../Pages/Locomotive/LocomotiveWorkOrderEdit';
import CheckRidePdf from '../Pages/Employee/Safety/CheckRidePdf';
import SystemAdminPage from '../Pages/HR/Employees/systemAdminPage';
import FuelManagement from '../Pages/FuelManagement/FuelManagement';
import PayrollTicket from '../Pages/PayrollTicket/PayrollTicket';
import PendingPayrollTickets from '../Pages/PayrollTicket/PendingPayrollTickets';
import PayrollTicketPage from '../Pages/PayrollTicket/PayrollTicketPage';
import PendingPayrollTicketDetail from '../Pages/PayrollTicket/PendingPayrollTicketDetail';
import EnterAudit from '../Pages/Employee/Safety/EnterAudit';
import AuditTabView from '../Pages/Employee/Safety/AuditTabView';
import FuelManagementMainPage from '../Pages/FuelManagement/fuelManagementMain';
import EntraLogin from '../Pages/Start/EntraLogin';
import EnterAuditTerminal from '../Pages/Employee/Safety/EnterAuditTerminal';

const { employee } = services;

const Routing = () => {


  return (<Router>
    {pageRoutes?.applicant?.map(route => <Route exact path={route?.path} component={() => <LoaderLayout>{route?.component}</LoaderLayout>} />)}
    {pageRoutes?.employee?.map(route => <Route exact path={route?.path} component={() => <LoaderLayout>{route?.component}</LoaderLayout>} />)}
  </Router >)

}
export default Routing;



export const pageRoutes = {
  applicant: [
    { path: "/", component: <Login /> },
    // Applicant On-boarding
    { path: "/application1", component: <Application /> },
    { path: "/create-password", component: <CreatePassword /> },
    { path: "/questionnaire", component: <Layout children={<Questionnaire status={1} />} /> },
    { path: "/documents", component: <Layout children={<Documents status={2} />} /> },
    { path: "/submission", component: <Layout children={<Submission status={3} />} /> },
    { path: "/hr-2nd-approval", component: <Layout children={<Submission5 status={6} />} /> },
    { path: "/applicant-rejected", component: <Layout children={<ApprovalRejected status={5} />} /> },
    { path: "/documents/step/3", component: <Layout children={<DocumentsStep3 status={4} />} /> },
    { path: "/documents/step/4", component: <Layout children={<DocumentsStep4 status={7} />} /> },
    { path: "/submission/complete", component: <Layout children={<SubmissionComplete status={9} />} /> },
    // Documents
    { path: "/documents/conditional-offer", component: <Layout children={<ConditionalOffer />} /> },
    { path: "/documents/post-conditional-job-offer", component: <Layout children={<PostConditionalJobOffer />} /> },
    { path: "/documents/post-conditional-job-offer/2", component: <Layout children={<PostConditionalJobOffer2 />} /> },
    { path: "/documents/post-conditional-job-offer/3", component: <Layout children={<PostConditionalJobOffer3 />} /> },
    { path: "/documents/post-conditional-job-offer/4", component: <Layout children={<PostConditionalJobOffer4 />} /> },
    { path: "/documents/driver-information", component: <Layout children={<DriverInformation />} /> },
    { path: "/documents/fuel-card-agreement", component: <Layout children={<FuelCardAgreement />} /> },
    { path: "/documents/boot-card-agreement", component: <Layout children={<BootCardAgreement />} /> },
    { path: "/documents/twic-card-payment-agreement", component: <Layout children={<TWICCardPaymentAgreement />} /> },
    { path: "/documents/direct-deposit", component: <Layout children={<DirectDeposit />} /> },
    { path: "/documents/fcra", component: <Layout children={<FCRA />} /> },
    { path: "/documents/arbitration-agreement", component: <Layout children={<ArbitrationAgreement />} /> },
    { path: "/documents/companyPropertyReturn", component: <Layout children={<CompanyPropertyReturn />} /> },
    { path: "/documents/ReleaseAndDocumentation", component: <Layout children={<ReleaseAndDocumentation />} /> },
    { path: "/documents/employee-agreement", component: <Layout children={<EmployeeAgreement />} /> },
    { path: "/documents/harassment", component: <Layout children={<Harassment />} /> },
    { path: "/documents/employee-handbook", component: <Layout children={<EmployeeHandbook />} /> },
    { path: "/documents/safety-handbook", component: <Layout children={<SafetyHandbook />} /> },
    { path: "/documents/drug-alcohol-weapons", component: <Layout children={<DrugAlcoholWeapons />} /> },
    { path: "/documents/depositeform", component: <Layout children={<UpdatedDepositeForm />} /> },
    // Pages
    { path: "/on-borarding", component: <OnBoarding /> },
    { path: "/ContactInfo", component: <ContactInfoForm /> },
    { path: "/application", component: <ApplicationContact /> },
    { path: "/forgetPassword", component: <ApplicantForget /> },
    { path: "/applicant-password/:uid", component: <ApplicantPassword /> },


  ],
  employee: [
    { path: "/login/140040", component: <EmployeeLogin /> },
    { path: "/entra-id", component: <EntraLogin /> },
    { path: "/broadcast-messages", component: <EmployeeCheck children={<BroadcastMessages />} pageName="broadcast_message" /> },
    { path: "/fuel-management", component: <EmployeeCheck children={<FuelManagementMainPage />} pageName="fuel_management" /> },
    { path: "/dashboard", component: <Layout children={<Dashboard />} /> },
    // Safety Testing
    { path: "/safety-testing", component: <EmployeeCheck children={<Layout children={<SafetyTesting />} />} pageName="safety" /> },
    { path: "/enter-railroad-event", component: <EmployeeCheck children={<Layout children={<Railroad />} />} pageName="safety" /> },
    { path: "/enter-check-ride", component: <EmployeeCheck children={<Layout children={<EnterCheckRide />} />} pageName="safety" /> },
    { path: "/checkRidePdf", component: <EmployeeCheck children={<Layout children={<CheckRidePdf />} />} pageName="safety" /> },
    { path: "/enter-incident", component: <EmployeeCheck children={<Layout children={<EnterIncidentAntd />} />} pageName="safety" /> },
    { path: "/enter-audit", component: <EmployeeCheck children={<Layout children={<EnterAudit />} />} pageName="safety" /> },
    { path: "/enter-audit-terminal", component: <EmployeeCheck children={<Layout children={<EnterAuditTerminal />} />} pageName="safety" /> },
    //Audit View
    { path: "/AuditView", component: <EmployeeCheck children={<Layout children={<AuditTabView />} />} pageName="safety" /> },



    { path: "/enter-incident/:id", component: <EmployeeCheck children={<Layout children={<EnterIncidentAntd />} />} pageName="safety" /> },
    { path: "/add-event-rules", component: <EmployeeCheck children={<Layout children={<SafetyTestingEdit />} />} pageName="safety" /> },
    // Create Ticket
    { path: "/create-ticket", component: <EmployeeCheck children={<Layout children={<CreateTicket />} />} pageName="create_ticket" /> },
    // New Hire Queue
    { path: "/new-hire-queue", component: <EmployeeCheck children={<Layout children={<NewHireQueue />} />} pageName="new_hire_queue" /> },
    { path: "/new-hire-queue/details", component: <EmployeeCheck children={<Layout children={<NewHireStep1 />} />} pageName="new_hire_queue" /> },
    { path: "/new-hire-queue-it", component: <EmployeeCheck children={<Layout children={<NewHireQueueIT />} />} pageName="new_hire_queue_it" /> },
    { path: "/new-hire-queue/details/approval", component: <EmployeeCheck children={<Layout children={<NewHireStep2 />} />} pageName="new_hire_queue" /> },
    // Tickets
    { path: "/tickets-alerts", component: <EmployeeCheck children={<Layout children={<TicketsAndAlerts />} />} pageName="tickets_alerts" /> },
    { path: "/tickets-alerts/alert/details", component: <EmployeeCheck children={<Layout children={<AlartUpdate />} />} pageName="tickets_alerts" /> },
    { path: "/tickets-alerts/ticket/details", component: <EmployeeCheck children={<Layout children={<TicketUpdate />} />} pageName="tickets_alerts" /> },
    { path: "/tickets-alerts/ticket/update", component: <EmployeeCheck children={<Layout children={<TicketAndAlertUpdate />} />} pageName="tickets_alerts" /> },

    // Employees
    { path: "/employees", component: <EmployeeCheck children={<Layout children={<Employees />} />} pageName="employees" /> },
    { path: "/employees/result", component: <EmployeeCheck children={<Layout children={<EmployeeResult />} />} pageName="employees" /> },
    { path: "/employees-profile", component: <EmployeeCheck children={<Layout children={<EmployeesProfile />} />} pageName="employees" /> },
    { path: "/employees-profile/result", component: <EmployeeCheck children={<Layout children={<ProfileResult />} />} pageName="employees" /> },
    { path: "/employees-profile/termination", component: <EmployeeCheck children={<Layout children={<Termination />} />} pageName="employees" /> },
    { path: "/employees-profile/terminated", component: <EmployeeCheck children={<Layout children={<Terminated />} />} pageName="employees" /> },
    // Hardware
    { path: "/hardware", component: <EmployeeCheck children={<Layout children={<HardwareManagement />} />} pageName="hardware" /> },
    // Locomotive
    { path: "/locomotivelookup", component: <EmployeeCheck children={<Layout children={<LocomotiveLookup />} />} pageName="locomotiveMain" /> },
    { path: "/equipmentlookup", component: <EmployeeCheck children={<Layout children={<EquipmentLookup />} />} pageName="equipmentLookup" /> },
    { path: "/equipmentlookupedit", component: <EmployeeCheck children={<Layout children={<EquipmentLookUpEdit />} />} pageName="equipmentLookup" /> },
    { path: "/locomotivetickets", component: <EmployeeCheck children={<Layout children={<LocomotiveTickets />} />} pageName="locomotiveMain" /> },
    { path: "/Locomotiveworkorders", component: <EmployeeCheck children={<Layout children={<LocomotiveWorkOrders />} />} pageName="locomotive" /> },
    { path: "/Locomotivelisting", component: <EmployeeCheck children={<Layout children={<LocomotiveListing />} />} pageName="locomotive" /> },
    { path: "/LocomotiveEdit", component: <EmployeeCheck children={<Layout children={<LocomotiveEdit />} />} pageName="locomotiveMain" /> },
    { path: "/LocomotiveTicketEdit", component: <EmployeeCheck children={<Layout children={<LocomotiveTicketEdit />} />} pageName="locomotiveMain" /> },
    { path: "/Locomotive-work-order-edit", component: <EmployeeCheck children={<Layout children={<LocomotiveWorkOrderEdit />} />} pageName="locomotiveMain" /> },
    { path: "/systemAdminPage", component: <EmployeeCheck children={<Layout children={<SystemAdminPage />} />} pageName="equipmentLookup" /> },
    {
      path: "/payroll-tickets", component: <EmployeeCheck children={<Layout children={<PayrollTicket />} />} pageName="payroll" />
    },
    {
      path: "/payroll/ticket", component: <EmployeeCheck children={<Layout children={<PayrollTicketPage />} />} pageName="payroll" />
    },
    {
      path: "/pending-payroll-tickets", component: <EmployeeCheck children={<Layout children={<PendingPayrollTickets />} />} pageName="pending_payroll_Ticket" />
    },
    {
      path: "/pending-payroll-ticket-detail", component: <EmployeeCheck children={<Layout children={<PendingPayrollTicketDetail />} />} pageName="pending_payroll" />
    },



    // Payroll Ticket 
    // {
    //   path: "/payroll-tickets", component: <PayrollTicket />
    //   // <EmployeeCheck children={<Layout children={<PayrollTicket />} />} pageName="payroll" />
    // },
    // {
    //   path: "/payroll/ticket",
    //   component: <PayrollTicketPage />
    //   // component: <EmployeeCheck children={<Layout children={<PayrollTicketPage />} />} pageName="payroll" /> 
    // },
    // {
    //   path: "/pending-payroll-tickets",
    //   component: <PendingPayrollTickets />
    //   // component: <EmployeeCheck children={<Layout children={<PendingPayrollTickets />} />} pageName="pending_payroll" /> 
    // },
    // {
    //   path: "/pending-payroll-ticket-detail",
    //   component: <PendingPayrollTicketDetail />
    //   // component: <EmployeeCheck children={<Layout children={<PendingPayrollTicketDetail />} />} pageName="pending_payroll" />
    // },

    // Department
    {
      path: "/human-resources", component: <EmployeeCheck children={<Layout
        children={<DepartmentInner
          api={employee.department_contact_list}
          apiID={5}
          ColumnsData={HTDept}
          pageName="HR Department" />}
      />} pageName="deparment" />
    },
    {
      path: "/safety", component: <EmployeeCheck children={<Layout children={
        <DepartmentInner
          api={employee.department_contact_list}
          apiID={1}
          ColumnsData={HTDept}
          pageName="Safety"
          safety />} />} pageName="deparment" />
    },
    {
      path: "/operations", component: <EmployeeCheck children={<Layout
        children={
          <DepartmentInner
            api={employee.department_contact_list}
            apiID={3}
            ColumnsData={HTDept}
            pageName="Operations" />} />} pageName="deparment" />
    },
    {
      path: "/information-technology", component: <EmployeeCheck children={<Layout children={
        <DepartmentInner
          api={employee.department_contact_list}
          apiID={2}
          ColumnsData={HTDept}
          pageName="Information Technology" />} />} pageName="deparment" />
    },
  ]
}

